export default {"src":"/_next/static/media/threads-icon.db38fd3d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};